import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-sm-6" }
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = { class: "col-sm-6" }
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_autocomplete = _resolveComponent("autocomplete")!
  const _component_gerita_list = _resolveComponent("gerita-list")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[4] || (_cache[4] = _createElementVNode("label", null, " Etichetta ", -1)),
      _withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localValue.sectionName) = $event)),
        class: "form-control"
      }, null, 512), [
        [_vModelText, _ctx.localValue.sectionName]
      ])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[5] || (_cache[5] = _createElementVNode("label", null, " Nome property onOffice (autocomplete search) ", -1)),
          _createVNode(_component_autocomplete, {
            modelValue: _ctx.localValue.onOfficePropertyName,
            "onUpdate:modelValue": [
              _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localValue.onOfficePropertyName) = $event)),
              _ctx.setType
            ],
            searchCallback: _ctx.searchCb,
            resultCallback: _ctx.resultCb,
            printCallback: _ctx.printCb,
            fields: _ctx.fields
          }, {
            "list-item": _withCtx(({ item }) => [
              _createTextVNode(_toDisplayString(_ctx.printCb(item)), 1)
            ]),
            _: 1
          }, 8, ["modelValue", "searchCallback", "resultCallback", "printCallback", "fields", "onUpdate:modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _cache[6] || (_cache[6] = _createElementVNode("label", null, " Nome property onOffice (free text input, for property not found by autocomplete) ", -1)),
          _withDirectives(_createElementVNode("input", {
            class: "form-control",
            type: "text",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localValue.onOfficePropertyName) = $event))
          }, null, 512), [
            [_vModelText, _ctx.localValue.onOfficePropertyName]
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _cache[7] || (_cache[7] = _createElementVNode("label", null, " Tipo di dato ", -1)),
      _withDirectives(_createElementVNode("select", {
        class: "form-control",
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.localValue.dataType) = $event))
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataTypes, (item, i) => {
          return (_openBlock(), _createElementBlock("option", {
            key: i,
            value: item
          }, _toDisplayString(item), 9, _hoisted_8))
        }), 128))
      ], 512), [
        [_vModelSelect, _ctx.localValue.dataType]
      ])
    ]),
    _createVNode(_component_gerita_list, {
      list: _ctx.localValue.gerItas
    }, null, 8, ["list"])
  ]))
}